import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Trash2, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const DeleteModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  const { t } = useTranslation('shared');
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100000]"
            onClick={onClose}
          />

          <motion.div
            className="fixed inset-0 flex items-center justify-center z-[100001] p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.94, y: 12 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.94, y: 8 }}
              transition={{ duration: 0.2, ease: [0.23, 1, 0.32, 1] }}
              className="w-full max-w-sm bg-[var(--color-bg-base)] rounded-2xl border border-white/[0.08] shadow-[0_32px_80px_rgba(0,0,0,0.7)] overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="flex items-start justify-between p-6 pb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-red-500/10 border border-red-500/20 flex items-center justify-center flex-shrink-0">
                    <Trash2 className="w-5 h-5 text-red-400" strokeWidth={2} />
                  </div>
                  <h3 className="text-base font-semibold text-[var(--color-text-primary)]">
                    {title || t('deleteModal.defaultTitle')}
                  </h3>
                </div>
                <button
                  onClick={onClose}
                  className="p-1.5 rounded-lg text-[#4a6380] hover:text-[var(--color-text-secondary)] hover:bg-white/[0.06] transition-colors flex-shrink-0"
                >
                  <X className="w-4 h-4" />
                </button>
              </div>

              {/* Content */}
              <div className="px-6 pb-6">
                <p className="text-sm text-[var(--color-text-muted)] leading-relaxed mb-6">
                  {message || t('deleteModal.defaultMessage')}
                </p>

                <div className="flex items-center justify-end gap-2">
                  <button
                    onClick={onClose}
                    className="px-4 py-2 rounded-xl text-sm font-medium text-[var(--color-text-muted)] hover:text-[var(--color-text-secondary)] hover:bg-white/[0.05] transition-colors"
                  >
                    {t('deleteModal.no')}
                  </button>
                  <button
                    onClick={onConfirm}
                    className="px-4 py-2 rounded-xl text-sm font-semibold bg-red-500/90 hover:bg-red-500 text-white transition-colors"
                  >
                    {t('deleteModal.yesDelete')}
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default DeleteModal;
